import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(id: string): Promise<Optional<ResponseData>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/CarbonDioxideLabel/${id}`;
	return axios.get(url).toOptionalMapped((x) => x.data);
}

export interface Response {
	data: ResponseData;
}

export type ResponseData = {
	id: string;
	labelTranslations: {
		[key: string]: string;
	};
	maxValue: number;
	color: string;
};

export const defaultResponseData = (): ResponseData => {
	return {
		id: '',
		labelTranslations: {},
		maxValue: 0,
		color: '',
	};
};
